export const validatePhone = (phone: string) => {
  const regexp = /^\+?\d{7,15}$/
  return phone.replace(/ *\(*\)*-*/g, '').match(regexp)
}
